import $ from 'jquery';
import utils from 'util/Util.js'
import constants from 'Constants.js';
import Immutable from 'immutable';
import themeService from 'ThemeService.js';
import BasePropertyView from 'BasePropertyView.js';
import formatTemplate from 'properties/main/mask.ejs';

import mobileSyncService from "../../../service/mobile/MobileSyncService";

class MainMaskView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = formatTemplate;
        this.tagName = 'div';
        this.id = opts.el;
        this.config = opts.config || {};

        this.events = {
            'change input[type=text]' : 'updateAttributes',
            'blur input[type=text]'   : 'lostFocus',
            'focus input[type=text]'   : 'getFocus'
        };

        // Add needed property
        if (!this.model.get('mask')) {
            this.model.set('mask', '###-#######', {silent: true});
        }

        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = utils.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));

        this.model.set(propName, propVal);
        mobileSyncService.synchronizeMobileForm(this.model, this.model.get('factoryKey'), {key: propName, val: propVal });
        
        //PF-6284 This calculation for the width was not accurate with the mask control in the designer
        //this.calculateWidth();
    }

    calculateWidth() {
        let font = [
            this.resolveThemeFontProperty('fontFamily'),
            this.resolveThemeFontProperty('fontSize'),
            this.resolveThemeFontProperty('textWeight'),
            this.resolveThemeFontProperty('textStyle')
        ];
        
        let charWidth = utils.measureText('X', font.join(','));
        let width = charWidth * this.model.get('mask').length;

        this.model.set('width', width);
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        if (this.config.showTitle) {
            this.$el.find('.propTitle').removeClass('hide');
        }

        this.delegateEvents();
        return this;
    }

}

export default MainMaskView;
